import { Button, Modal, modalWidth } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { useConfig } from "shared/components/ConfigContext"
import Layout from "shared/components/Layout"
import PageError from "shared/components/PageError"
import PageSpinner from "shared/components/PageSpinner"
import { useCatalogSummariesQuery } from "shared/hooks/queries"
import { sortCatalogSummaries } from "shared/hubrise/utils/CatalogSummary"

import { useEditorStoreContext } from "../shared/components/EditorStoreContext"

import Catalog from "./Catalog"
import CreateModalContent from "./CreateModalContent"
import { Controls, Header, Main, Title } from "./Styles"

const Home = (): JSX.Element => {
  const { t } = useTranslation()
  const { appInstanceId } = useConfig()

  const { openEditors } = useEditorStoreContext()

  const { data: catalogSummaries, error } = useCatalogSummariesQuery(appInstanceId)

  if (error) return <PageError error={error} />
  if (!catalogSummaries) return <PageSpinner />

  const sortedCatalogSummaries = sortCatalogSummaries(catalogSummaries)
  return (
    <Layout hasPopupOverlay={true}>
      <Main>
        <Header>
          <Title>{t("catalogs.title")}</Title>

          <Controls>
            <Modal
              modalWidth={modalWidth.small}
              renderLink={({ open }) => <Button onClick={open}>{t("catalogs.create.title")}</Button>}
              renderContent={({ close }) => <CreateModalContent {...{ catalogSummaries, close }} />}
            />
          </Controls>
        </Header>

        {sortedCatalogSummaries.map((catalogSummary, idx) => {
          const editor = openEditors[catalogSummary.id]
          const unsaved = editor !== undefined && editor.unsaved
          return <Catalog key={idx} {...{ catalogSummary, catalogSummaries, editor, unsaved }} />
        })}
      </Main>
    </Layout>
  )
}

export default Home
